import { StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';
import { widthPercentageToDP } from 'utils/responsiveness';

const styles = StyleSheet.create({
    leftNavigationBar: {
        flex: 1,
        justifyContent: 'flex-end',
        alignItems: 'center',
        position: 'absolute',
        left: 0,
        bottom: 0,
        width: widthPercentageToDP(72),
        height: '100%',
        backgroundColor: COLOR.background,
        paddingBottom: 28,
    },
    rightNavigationBar: { right: 0, left: 'auto' },
    arrowFwd: { transform: [{ rotate: '180deg' }] },
});

export default styles;
